/* web/app/components/animated-digit/animated-digit.component.scss */
/*# sourceMappingURL=animated-digit.component.css.map */
